/**
 * Hook to get the current crew member using Supabase authentication
 */

import { useAuth } from '@/hooks/useAuth'
import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../lib/orpc'

/**
 * Get the current authenticated crew member
 * Returns the crew data from the backend based on Supabase user ID
 */
export function useCurrentCrewMember() {
  const { isSignedIn, userId } = useAuth()
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.crew.getBySupabaseUserId.queryOptions({
    input: {
      supabaseUserId: userId!
    },
    enabled: !!isSignedIn,
  }))

}

